'use client';

/**
 * ./src/modules/brand/components/BrandPromotions.tsx
 *
 * BrandPromotions component to display the promotion tickets section for the brand page.
 *
 * @copyright DesignShop, 2024
 * @since 12/16/2024
 */
import { DataLayerWhere } from '@/modules/cart/services/data-layer-events/add-to-cart';
import { PromotionTicket, getValidPromos } from '@/modules/product/components/modal/PromotionModal';

import { Promo } from '@/gql/__generated/graphql.types';

type BrandPromotionsProps = {
  promotions: Promo[];
  brandId?: string | null;
};
export const BrandPromotions = ({ promotions, brandId }: BrandPromotionsProps) => {
  const validPromos = getValidPromos(promotions);

  if (!validPromos?.length) {
    return null;
  }

  return (
    <div className="mx-auto mb-[3.75rem] w-full px-4 lg:px-8">
      <h2 className="mb-5 text-2xl font-bold lg:text-[28px]/[32px]">Current Promotions</h2>
      <ul className="flex flex-wrap gap-2">
        {validPromos.map((promo) => {
          if (!promo) {
            return null;
          }

          return (
            <li key={promo.code} className="w-full lg:w-[416px]">
              <PromotionTicket
                title={promo.name}
                code={promo.code}
                where={DataLayerWhere.BrandPage}
                validUntil={promo.endYyyymmddET}
                disclaimer={promo.description}
                brandId={brandId}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};
